<template>
  <div
    class="view">
    <HomeNavigation />

    <div
      class="home-content">
      <div
        class="collections-header">
        <div class="collections-header-left">
          <div class="collections-header-name">
            <!-- Welcome, {{ username }}! -->
          </div>
        </div>
      </div>

      <div class="home-message">
        {{ username.toLowerCase() }}'s byblio
      </div>

      <div class="home-flex-container">
        <div class="left">
          <div class="get-started-container" v-if="false">
            Welcome to the beta version of <span class="byblio">Byblio</span>!<br><br>
            Do you have a feature request, feedback, or have you found a bug? Please email me at <a href="mailto:annealbert@bybl.io" class="mail-to">annealbert@bybl.io</a>!<br><br>
            <!-- <span class="start-tutorial" @click="$navigateTo({ name: 'HowToUse' })">
              <i class="mdi mdi-arrow-right" /> How to use Byblio
            </span> -->
            <span class="start-tutorial" @click="requestFile()">
              <i class="mdi mdi-arrow-right" /> Request file
            </span>
          </div>
          <div class="quick-notes-container">
            <div class="sub-header">
              Quick notes
            </div>
            <div class="quick-notes">
              <editor-floating-menu
                :editor="editor"
                class="floating-menu-container"
                v-slot="{ commands, isActive, menu }">
                <div
                  class="floating-menu"
                  :class="{ 'is-active': menu.isActive && !menuHidden }"
                  :style="`top: ${Math.min(
                    !!$refs.editor && $refs.editor.$el.clientHeight - (1.3 * remInPx), /* to prevent the menu from overflowing the editor, which screws over the whole layout */
                    menu.top
                  )}px`">
                  <div
                    class="menu-item"
                    :class="{ 'is-active': isActive.bold() }"
                    @click="commands.bold">
                    <i class="mdi mdi-format-bold mdi-18px" />
                  </div>
                  <div
                    class="menu-item"
                    :class="{ 'is-active': isActive.italic() }"
                    @click="commands.italic">
                    <i class="mdi mdi-format-italic mdi-18px" />
                  </div>
                  <div
                    class="menu-item"
                    :class="{ 'is-active': isActive.underline() }"
                    @click="commands.underline">
                    <i class="mdi mdi-format-underline mdi-18px" />
                  </div>
                  <div
                    class="menu-item"
                    :class="{ 'is-active': isActive.bullet_list() }"
                    @click="commands.bullet_list">
                    <i class="mdi mdi-format-list-bulleted mdi-18px" />
                  </div>
                  <div
                    class="menu-item"
                    :class="{ 'is-active': isActive.ordered_list() }"
                    @click="commands.ordered_list">
                    <i class="mdi mdi-format-list-numbered mdi-18px" />
                  </div>
                  <div
                    class="menu-item"
                    :class="{ 'is-active': isActive.todo_list() }"
                    @click="commands.todo_list()">
                    <i class="mdi mdi-format-list-checks mdi-18px" />
                  </div>
                </div>
              </editor-floating-menu>
              <editor-content
                class="editor"
                :editor="editor"
                ref="editor"
                v-scroll="hideMenu"
                spellcheck="false" />
            </div>
          </div>
        </div>
        <div class="right">
          <div class="right-item-container">
            <div class="sub-header sub-header-lists" v-if="false">
              Pinned items
            </div>
            <div class="home-list" v-if="false">
              <div
                v-if="!(pinnedCards.length + pinnedNotes.length)"
                class="no-pinned-items">
                You do not have pinned cards or notes.
              </div>
              <div
                v-for="card in pinnedCards"
                :key="card.id"
                class="home-list-item"
                @click="$goToCard(card)">
                <i :class="getIcon(card)" />
                {{ card.title }}
              </div>
              <div
                v-for="note in pinnedNotes"
                :key="note.id"
                class="home-list-item"
                @click="$goToNote(note)">
                <i :class="getIcon(note)" />
                {{ note.title }}
              </div>
            </div>
          </div>
          <div class="right-item-container">
            <div class="sub-header sub-header-lists">
              Recently added
            </div>
            <div class="home-list">
              <div
                v-for="item in recentlyAdded"
                :key="item.id"
                class="home-list-item"
                @click="goToItem(item)">
                <i :class="getIcon(item)" />
                {{ item.title }}
              </div>
            </div>
          </div>
          <div class="right-item-container">
            <div class="sub-header sub-header-lists">
              Recently modified
            </div>
            <div class="home-list">
              <div
                v-for="item in recentlyWorkedOn"
                :key="item.id"
                class="home-list-item"
                @click="goToItem(item)">
                <i :class="getIcon(item)" />
                {{ item.title }}
              </div>
            </div>
          </div>
        </div>
        <div class="bottom">
          <div class="logout" @click="logout">
            <i class="mdi mdi-power" /> Sign out
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { Editor, EditorContent, EditorFloatingMenu } from 'tiptap';
import { HardBreak, Bold, Italic, Underline, BulletList, OrderedList, ListItem, TodoItem, TodoList, Link, Placeholder } from 'tiptap-extensions';
import parseISO from 'date-fns/parseISO';
import compareAsc from 'date-fns/compareAsc';
import HomeNavigation from '@/components/AppView/HomeNavigation.vue';
const debounce = require('lodash/debounce');

export default {
  name: 'Home',
  components: {
    HomeNavigation,
    EditorContent,
    EditorFloatingMenu,
  },
  directives: {
    scroll: {
      inserted: function (el, binding) { // eslint-disable-line 
        let f = function (evt) { // eslint-disable-line 
          if (binding.value(evt, el)) {
            el.removeEventListener('scroll', f);
          }
        };
        el.addEventListener('scroll', f);
      },
    },
  },
  data() {
    return {
      saving: false,
      numberOfRecentItems: 7,
      editor: new Editor({
        editable: true,
        extensions: [
          new HardBreak(),
          new Bold(),
          new Italic(),
          new Underline(),
          new BulletList(),
          new OrderedList(),
          new ListItem(),
          new TodoItem({ nested: true }),
          new TodoList(),
          new Link(),
          new Placeholder({
            emptyEditorClass: 'is-editor-empty',
            emptyNodeClass: 'is-empty',
            emptyNodeText: 'Leave some quick notes...',
            showOnlyWhenEditable: false,
            showOnlyCurrent: false,
          }),
        ],
        onUpdate: debounce(({ getHTML }) => {
          this.$store.dispatch('users/updateUser', { quickNotes: getHTML() });
        }, 500),
        onTransaction: () => {
          this.menuHidden = false;
        },
        disablePasteRules: ['italic'],
      }),
      menuHidden: true,
      unsubscribeVuex: null,
    };
  },
  computed: {
    ...mapState({
      collectionNodes: state => state.collections.collectionNodes,
      archivedCollectionNodes: state => state.collections.archivedCollectionNodes,
      selectedCollection: state => state.collections.selectedCollection,
      userId: state => state.users.internalUserId,
      name: state => state.users.userInfo.name,
      firstName: state => state.users.userInfo.firstName,
      lastName: state => state.users.userInfo.lastName,
      email: state => state.users.userInfo.email,
      cards: state => state.cards.cards,
      notes: state => state.notes.notes,
      pinnedCardIds: state => state.users.settings.pinnedCards,
      pinnedNoteIds: state => state.users.settings.pinnedNotes,
      quickNotes: state => state.users.quickNotes,
    }),
    ...mapGetters({
      getCardRef: 'cards/getCardRef',
      getNoteRef: 'notes/getNoteRef',
    }),
    remInPx() {
      return parseFloat(getComputedStyle(document.documentElement).fontSize);
    },
    username() {
      if (this.name) return this.name;
      if (this.firstName && this.lastName) return `${this.firstName} ${this.lastName}`;
      if (this.firstName) return this.firstName;
      if (this.lastName) return this.lastName;
      return this.email;
    },
    allCards() {
      // Gathers all cards from non-archived collection in one array
      let allCards = [];
      const collectionIds = Object.keys(this.collectionNodes);
      collectionIds.forEach((collectionId) => {
        if (!this.cards[collectionId]) return;
        allCards = allCards.concat(this.cards[collectionId]);
      });
      return allCards;
    },
    allNotes() {
      // Gathers all notes from non-archived collection in one array
      let allNotes = [];
      const collectionIds = Object.keys(this.collectionNodes);
      collectionIds.forEach((collectionId) => {
        if (!this.notes[collectionId]) return;
        allNotes = allNotes.concat(this.notes[collectionId]);
      });
      return allNotes;
    },
    recentlyAddedCards() {
      const cardsToSort = this.allCards;
      const sortedModified = cardsToSort.sort((a, b) => compareAsc(parseISO(b.dateCreated), parseISO(a.dateCreated)));
      return sortedModified.slice(0, this.numberOfRecentItems);
    },
    recentlyWorkedOnCards() {
      const cardsToSort = this.allCards;
      const sortedModified = cardsToSort.sort((a, b) => compareAsc(parseISO(b.dateLastModified), parseISO(a.dateLastModified)));
      return sortedModified.slice(0, this.numberOfRecentItems);
    },
    recentlyAddedNotes() {
      const notesToSort = this.allNotes;
      const sortedModified = notesToSort.sort((a, b) => compareAsc(parseISO(b.dateCreated), parseISO(a.dateCreated)));
      return sortedModified.slice(0, this.numberOfRecentItems);
    },
    recentlyWorkedOnNotes() {
      const notesToSort = this.allNotes;
      const sortedModified = notesToSort.sort((a, b) => compareAsc(parseISO(b.dateLastModified), parseISO(a.dateLastModified)));
      return sortedModified.slice(0, this.numberOfRecentItems);
    },
    recentlyAdded() {
      const toSort = this.recentlyAddedCards.concat(this.recentlyAddedNotes);
      const sorted = toSort.sort((a, b) => compareAsc(parseISO(b.dateCreated), parseISO(a.dateCreated)));
      return sorted.slice(0, this.numberOfRecentItems);
    },
    recentlyWorkedOn() {
      const toSort = this.recentlyWorkedOnCards.concat(this.recentlyWorkedOnNotes);
      const sorted = toSort.sort((a, b) => compareAsc(parseISO(b.dateLastModified), parseISO(a.dateLastModified)));
      return sorted.slice(0, this.numberOfRecentItems);
    },
    pinnedCards() {
      return this.pinnedCardIds.map(cardId => this.getCardRef({ cardId }));
    },
    pinnedNotes() {
      return this.pinnedNoteIds.map(noteId => this.getNoteRef({ noteId }));
    },
  },
  methods: {
    requestFile() {
      this.$store.dispatch('files/getFile', {});
    },
    logout() {
      // >>> Not implemented, this is still old stuff
      // this.$store.commit('appState/SetScreenOverlayLogout');
      // localStorage.removeItem('selectedCollection');
      // localStorage.removeItem('sidebarWidth');
      // localStorage.removeItem('collectionViewSortSetting');
      // this.$auth.logout();
    },
    getIcon(item) {
      // Cards have a note attribute
      if (item.note || item.note === null) {
        // if (item.item && item.item.type === 'webpage') return 'mdi mdi-open-in-new';
        // if (item.item && item.item.type === 'file') return 'mdi mdi-paperclip mdi-rotate-45';
        return 'mdi mdi-card-text-outline';
      }
      // Notes
      return 'mdi mdi-text';
    },
    goToItem(item) {
      // Check card or note
      const isCard = item.note || item.note === null;
      if (isCard) this.$goToCard(item);
      else this.$goToNote(item);
    },
    hideMenu() {
      this.menuHidden = true;
    },
  },
  mounted() {
    this.editor.setContent(this.quickNotes);
    this.unsubscribeVuex = this.$store.subscribe((mutation) => {
      // The check on mutation.payload number of entries is to prevent this from running when simply editing the content
      // (uses the same mutation, but only has quickNotes as payload record, in contrast to polling that resets the whole userInfo)
      if (mutation.type === 'users/SetUserInfo' && Object.keys(mutation.payload).length > 1) {
        this.editor.setContent(this.quickNotes);
      }
    });
  },
  beforeDestroy() {
    this.editor.destroy();
    this.unsubscribeVuex();
  },
};
</script>

<style lang="scss" scoped>
@import '~styles/colors';
@import '~styles/fonts';
@import '~styles/layouts';

.root-container {
  overflow-y: scroll;
  height: calc(100vh - 2.875rem - 1.5rem); // minus navigation and top bar thingy
  padding-top: 2rem;
}
.container {
  max-width: none !important;
  overflow-y: auto;
}
.view {
  position: relative;
  height: 100vh;
  max-height: 100vh;
  overflow-y: hidden;
  overflow-x: hidden;
}
.collection-tabs {
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  width: 100%;
  z-index: 5;
  border-bottom: 1px solid $primary;
  font-size: 1.25rem;
  height: 2.875rem; // (font-size * 1.5 line-height) + 0.5 padding + 1px for border
  padding: 0 0 0 0;
  vertical-align: middle;
}
.collection-tab {
  flex: 0 0 auto;
  margin: 0 0 -1px 0;
  padding: 0.5rem 1.5rem;
  cursor: pointer;
}
.collection-tab-active {
  font-weight: 600;
}
.collection-tab > .mdi {
  opacity: 0.8;
}
.home-content {
  position: relative;
  height: calc(100% - 2.875rem); // minus collection tabs height
}
.collections-header {
  position: sticky;
  top: 10px;
  display: flex;
  width: 100%;
  padding: 0.125rem;
  font-size: 0.85rem;
  margin-bottom: 0.5rem;
  height: 1.5rem;
  font-size: 0.7rem;
  color: rgba($black, 0.75);
  background-color: rgba($primary, 0.25);
  user-select: none;
}
.collections-header div {
  display: inline-flex;
}
.collections-header-name {
  padding-left: 0.25rem;
}
.collections-header-left {
  flex-basis: 50%;
  display: flex;
  padding-left: 2rem;
}
.home-message {
  padding: 0.75rem 2rem 0;
  font-size: 1.5rem;
  font-family: $headerFont;
  // font-weight: bold;
  font-variant: small-caps;
  letter-spacing: 0.25rem;
  // text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.home-flex-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: stretch;
  align-content: stretch;
  max-height: calc(100% - 2rem - 2rem);
  overflow-y: auto;
  padding: 0.5rem 0 0;
  margin: 0;
}
.left,
.right {
  flex: 0 1 60%;
  height: 72vh;
  max-height: calc(100vh - 12rem);
  overflow-x: hidden;
  overflow-y: auto;
}
.left {
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
}
.right {
  flex: 0 1 36%;
  display: flex;
  flex-direction: column;
  padding: 0 0 1rem;
  margin-right: 2%;
}
.bottom {
  flex: 0 0 100%;
}
.right-item-container {
  flex: 1 1 auto;
  overflow-y: hidden;
  margin: 0 0 1rem;
  min-height: 5rem;
}
.right-item-container:first-child {
  flex: 1 0 auto;
  max-height: 50%;
}
.sub-header {
  // position: relative;
  // top: 1rem;
  position: sticky;
  top: 0;
  // margin-top: 1.5rem;
  font-family: $headerFont;
  font-size: 0.8rem;
  width: calc(100% - 1rem);
  height: 1.25rem;
  border-bottom: 1px solid $primary;
  padding: 0 2rem;
  margin: 0 0.5rem;
  background: #ffffff;
  z-index: 1;
}
.sub-header-lists {
  padding: 0 1rem;
}
.home-list {
  margin: 0.5rem 0.5rem 0.5rem 0;
  font-size: 0.9rem;
  height: calc(100% - 2.25rem);
  overflow-y: auto;
}
.home-list-item {
  padding: 0.125rem 2.5rem;
  cursor: pointer;
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}
.home-list-item:hover {
  background: #eeeeee;
}
.no-pinned-items {
  font-size: 0.8rem;
  padding-left: 1rem;
  font-style: italic;
}

// Get started stuff
.get-started-container {
  height: calc(40% - 4rem);
  min-height: 10rem;
  background-color: #f5f5f6;
  margin: 1.5rem 2rem;
  padding: 0.5rem 1rem;
  font-family: $headerFont;
  flex: 0 0 auto;
}
.start-tutorial {
  cursor: pointer;
  color: $secondary-dark;
  font-family: $bodyFont;
  font-size: 0.9rem;
  transition: color 0.2s;
}
.mail-to {
  color: $secondary-dark;
}
// Quick notes
.quick-notes-container {
  height: 60%;
  max-height: calc(100% - 13rem); // 13rem min height get-started container (incl margin)
  flex: 0 1 auto;
}
.quick-notes {
  position: relative;
  height: calc(100% - 1.25rem);
  width: 100%;
  padding: 0 1.5rem;
  font-size: 0.9rem;
  font-family: $quattrocentoSans;
  transition: all 0.3s;
  overflow: hidden;
}
.floating-menu {
  @include floating-menu;
  margin-left: 1.25rem;
}
.is-active {
  @include is-active;
}
.menu-item {
  @include menu-item;
}
.menu-item:hover {
  opacity: 1;
}
.editor {
  height: 100%;
  overflow: hidden;
  cursor: text;
  @include prosemirror-for-editor;

  ::v-deep .ProseMirror {
    min-height: 100%;
    max-height: 100%;
    padding: 1.5rem 1.5rem 0;
    padding-bottom: 0;
    overflow-y: auto;
    overflow-x: hidden;
  }

  ::v-deep .ProseMirror:hover,
  ::v-deep .ProseMirror:focus {
  background-color: #f5f5f6;
  }

  ::v-deep p.is-editor-empty:first-child::before {
    content: attr(data-empty-text);
    float: left;
    color: #aaa;
    font-style: italic;
    font-size: 0.9rem;
    height: 0;
    pointer-events: none;
    transition: opacity 0.2s;
    transition-delay: display 0.2s;
  }

  ::v-deep .ProseMirror:focus p.is-editor-empty:first-child::before {
    opacity: 0;
    display: none;
  }
}

// Logout
.logout {
  border-top: 1px solid $primary;
  width: 100%;
  min-height: 2rem;
  padding: 0.5rem 2rem;
  font-size: 0.8rem;
  cursor: pointer;
  font-style: italic;
}
.logout:hover {
  background: $primary;
}
</style>
